import React, { useRef } from 'react';
import { IconButton, SvgIcon, Tooltip } from '@material-ui/core';
import { Sun, Moon } from 'react-feather';
import useSettings from 'src/hooks/useSettings';
import { THEMES } from 'src/constants';

function Settings() {
  const ref = useRef(null);
  const { settings, saveSettings } = useSettings();

  const handleSave = newconfig => {
    saveSettings(newconfig);
  };

  const handleToggle = stTheme => {
    handleSave({
      direction: settings.direction,
      responsiveFontSizes: settings.responsiveFontSizes,
      theme: stTheme,
    });
  };

  return (
    <>
      <Tooltip placement='right' title='Theme'>
        {settings.theme === THEMES.ONE_DARK ? (
          <IconButton onClick={e => handleToggle(THEMES.LIGHT)} ref={ref}>
            <SvgIcon fontSize='small'>
              <Sun />
            </SvgIcon>
          </IconButton>
        ) : (
          <IconButton onClick={e => handleToggle(THEMES.ONE_DARK)} ref={ref}>
            <SvgIcon fontSize='small'>
              <Moon />
            </SvgIcon>
          </IconButton>
        )}
      </Tooltip>
    </>
  );
}

export default Settings;
